'use client';

import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { cn } from '@/lib/utils';

function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name = '') {
  const nameParts = name.trim().split(' ');
  const initials = nameParts.length >= 2
    ? `${nameParts[0][0]}${nameParts[1][0]}`
    : nameParts[0][0];

  return {
    bgcolor: stringToColor(name),
    children: initials.toUpperCase(),
  };
}

export function UserAvatar({ name, className = '' }) {
  const avatarProps = stringAvatar(name);

  return (
    <Avatar
        component="div"
        className={cn('flex items-center justify-center text-white', className)}
        sx={{
            bgcolor: avatarProps.bgcolor, // only color in sx
        }}
        >
        {avatarProps.children}
    </Avatar>
  );
}
